import { proStatusOptionsFor, resolveProStatus } from '../../../shared/utils/pro-status-rules';
import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {AuthService} from '../../../services/auth.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {EstablishmentService} from '../../../services/establishment.service';
import {
  civilityForProfileOptions,
  civilityOptions,
  registerNationalityOptions,
} from '../../../shared/utils/data/etablissments-data';
import {FlagType, userType} from '../../../shared/utils/enums';
import {
  CountryISO,
  PhoneNumberFormat,
  SearchCountryField,
} from '@justin-s/ngx-intl-tel-input';
import {CandidatService} from '../../../services/candidat.service';
import {MissionService} from './../../../services/mission.service';
import {FlagService} from '../../../shared/services/flag.service';
import {AlertDialogService} from '../../../services/alert-dialog.service';
import {MatDialog} from '@angular/material/dialog';
import moment from 'moment';
import {ActivatedRoute, Router} from '@angular/router';
import {Base64} from '../../../shared/utils/utils.functions';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
})
export class ProfileComponent implements OnInit {
  getAdresseFormated(option: any) {
    const address = option?.address || {};
    const house_number = address?.house_number || '';
    const road = address?.road || '';
    const postcode = address?.postcode || '';
    const city = address?.city || '';
    const country = address?.country || '';
    const addressComponents = [
      house_number,
      road,
      `${postcode} ${city}`,
      country
    ];
    const filteredComponents = addressComponents.filter(component => component.trim() !== '');
    return filteredComponents.join(', ')
  }

  submitSecurity() {
    throw new Error('Method not implemented.');
  }

  image: string;
  loading = false;
  birthDay: string;
  graduationYear: string;
  maxDate: string;
  loadingSecurity = false;
  phoneNumber: string | undefined;
  loadingDocuments = false;
  nonAvailabilityDates = '';
  isCondidat: boolean = true;
  userId: any;
  candidatBody: any;
  domaineOptions: any[];
  allPostes: any[];
  fonctionOptions: any[];
  PhoneNumberFormat = PhoneNumberFormat;
  /** Statut pro (B1) : VACATAIRE | TITULAIRE | REMPLACANT — défaut VACATAIRE */
  /** Options filtrées selon la fonction (médecin : remplaçant ; infirmier : vacataire / titulaire). */
  proStatusOptions: { id: string; name: string }[] = proStatusOptionsFor(null);
  today = moment(new Date()).format('DD-MM-YYYY');
  addressList: any[] = [];
  addressLoading = false;
  addressSearched = false;
  private searchSubject = new Subject<string>();
  phoneMaxLength: number = 10;
  identityCartOpt = [
    {id: 1, name: 'Carte d’identité'},
    {id: 2, name: 'Passeport'},
  ];
  justificatifDomicileOptn = [
    { id: 2, name: 'Justificatif de domicile au nom du demandeur' },
    { id: 1, name: 'Hébergement par une autre personne' },
  ];
  justificatifDomicileOptn2 = [
    {id: 1, name: 'Facture de téléphone', fromData: 'phoneBill'},

    {
      id: 2,
      name: `Facture d'électricité ou de gaz`,
      fromData: 'electroBill',
    },
    {
      id: 3,
      name: `Quittance de loyer émanant d'un organisme social ou d'une agence immobilière`,
      fromData: 'quittanceImmob',
    },
    {
      id: 4,
      name: `Titre de propriété`,
      fromData: 'propertyTitle',
    },
    {
      id: 5,
      name: `Facture d'eau`,
      fromData: 'waterBill',
    },
    {
      id: 6,
      name: `Avis d’imposition ou certification de non imposition`,
      fromData: 'certImpos',
    },
    {
      id: 7,
      name: `Justificatif de taxe d’habitation ou de taxe foncière`,
      fromData: 'taxBill',
    },
    {
      id: 8,
      name: `Attestation ou facture d'assurance du logement`,
      fromData: 'assuranceLogement',
    },
  ];
  pdfLists = [
    {
      id: 1,
      name: 'idFace',
      fileName: 'idFace',
    },
    {
      id: 1,
      name: 'sejourFace',
      fileName: 'sejourFace',
    },
    {
      id: 1,
      name: 'sejourBack',
      fileName: 'sejourBack',
    },
    {
      id: 1,
      name: 'idBack',
      fileName: 'idBack',
    },
    {
      id: 1,
      name: 'bankDetails',
      fileName: 'bankDetails',
    },
    {
      id: 1,
      name: 'passport',
      fileName: 'passport',
    },
    {
      id: 1,
      name: 'socialSecurityCertif',
      fileName: 'socialSecurity',
    },
    {
      id: 1,
      name: 'letterSignedByHost',
      fileName: 'letterSigned',
    },
    {
      id: 1,
      name: 'justificatifDomicileHost',
      fileName: 'Host',
    },
    {
      id: 1,
      name: 'justificatifDomicile',
      fileName: 'justificatifDomicile',
    },
    {
      id: 1,
      name: 'phoneBill',
      fileName: 'phoneBill',
    },
    {
      id: 1,
      name: 'carteGrise',
      fileName: 'carteGrise',
    },
    {
      id: 1,
      name: 'enrollmentCertificate',
      fileName: 'enrollmentCertificate',
    },
    {
      id: 1,
      name: 'electroBill',
      fileName: 'electroBill',
    },
    {
      id: 1,
      name: 'quittanceImmob',
      fileName: 'quittanceImmob',
    },
    {
      id: 1,
      name: 'propertyTitle',
      fileName: 'propertyTitle',
    },
    {
      id: 1,
      name: 'waterBill',
      fileName: 'waterBill',
    },
    {
      id: 1,
      name: 'certImpos',
      fileName: 'certImpos',
    },
    {
      id: 1,
      name: 'taxBill',
      fileName: 'taxBill',
    },
    {
      id: 1,
      name: 'assuranceLogement',
      fileName: 'assuranceLogement',
    },
    {
      id: 1,
      name: 'cv',
      fileName: 'cvFile',
    },
    {
      id: 1,
      name: 'firstDiplome',
      fileName: 'Dipolome',
    },
    {
      id: 1,
      name: 'secondDiplome',
      fileName: 'Dipolome1',
    },
    {
      id: 1,
      name: 'thirdDiplome',
      fileName: 'Dipolome2',
    },
  ];
  identityCart = new FormGroup({
    value: new FormControl(1),
  });
  justificatifDomicile = new FormGroup({
    value: new FormControl(2),
  });
  justificatifDomicile2 = new FormGroup({
    value: new FormControl(1),
  });
  depatmentList: any;
  documentFormGroup: FormGroup = this.fb.group({
    idFace: [],
    idBack: [],
    sejourFace: [],
    sejourBack: [],
    passport: [],
    bankDetails: [],
    socialSecurityCertif: [],
    letterSignedByHost: [],
    justificatifDomicileHost: [],
    justificatifDomicile: [],
    phoneBill: [],
    electroBill: [],
    quittanceImmob: [],
    propertyTitle: [],
    waterBill: [],
    certImpos: [],
    taxBill: [],
    assuranceLogement: [],
    cv: ['', Validators.required],
    firstDiplome: ['', Validators.required],
    secondDiplome: [],
    thirdDiplome: [],
  });
  phoneForm = new FormGroup({
    phone: new FormControl({
      countryCode: '',
      dialCode: '',
      e164Number: '',
      internationalNumber: '',
      nationalNumber: '',
      number: '',
    }),
  });
  file: any[] = [];
  formAddress: FormGroup = this.fb.group({
    regionName: [''],
    regionCode: [''],
    lat: [''],
    lon: [''],
    adress: [''],
    postalCode: [''],
    pays: [''],
    ville: [''],
    departmentName: [''],
    note: ['', [Validators.maxLength(50)]],
  });
  form: FormGroup = !this.isCondidat
    ? this.fb.group({
      prefixe: [''],
      firstname: [''],
      lastname: [''],
      email: [{value: '', disabled: true}],
    })
    : this.fb.group({
      civility: ['', [Validators.required]],
      image: [''],
      firstname: ['', [Validators.required]],
      lastname: ['', [Validators.required]],
      birthDay: [''],
      graduationYear: [''],
      mailadress: [{value: '', disabled: true}],
      worktype: [''],
      nationality: [''],
      fonction: [''],
      proStatus: ['VACATAIRE', [Validators.required]],
      ishandicap: [''],
      key: ['', [Validators.maxLength(2), Validators.minLength(2)]],
      numsiret: ['', [Validators.maxLength(14), Validators.minLength(14)]],
      numsocialsecurity: ['', [Validators.maxLength(13), Validators.minLength(13)]],
      numtel: [''],
      phone: [],
      handicapsituation: ['']

    });

  formSecurity: FormGroup = this.fb.group({
    password: [''],
    confirmPassword: [''],
    newPassword: [''],
  });
  formPermanent: FormGroup = this.fb.group({
    candidat: null,
    id: [''],
    selectedDepartment: [[]],
    nonAvailabilityDates: [[]],
    worktype: [{value: '', disabled: true}],
    fonction: [{value: '', disabled: true}],
  });
  moment = moment;
  formData = new FormData();

  userID = 0;

  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    public establishmentService: EstablishmentService,
    private condidatApi: CandidatService,
    private missionApi: MissionService,
    private flag: FlagService,
    public router: Router,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private http: HttpClient,
    private alertDialogService: AlertDialogService

  ) {
    if (this.form.get('nationality')?.value != 'autre') {
      if (this.identityCart.get('value')?.value == 1) {
        this.documentFormGroup.controls['idFace'].setValidators([
          Validators.required,
        ]);
        this.documentFormGroup.controls['idBack'].setValidators([
          Validators.required,
        ]);
        this.documentFormGroup.controls['passport'].clearValidators();
      } else {
        this.documentFormGroup.controls['passport'].setValidators([
          Validators.required,
        ]);
        this.documentFormGroup.controls['idFace'].clearValidators();
        this.documentFormGroup.controls['idBack'].clearValidators();
      }
    } else {
      this.documentFormGroup.controls['idFace'].setValidators([]);
      this.documentFormGroup.controls['idBack'].setValidators([]);
      this.documentFormGroup.controls['passport'].setValidators([
        Validators.required,
      ]);
      this.documentFormGroup.controls['sejourFace'].setValidators([
        Validators.required,
      ]);
      this.documentFormGroup.controls['sejourBack'].setValidators([
        Validators.required,
      ]);
    }

    if (this.justificatifDomicile.get('value')?.value == 1) {
      this.documentFormGroup.controls['phoneBill'].setValidators([]);
      this.documentFormGroup.controls['electroBill'].setValidators([]);
      this.documentFormGroup.controls['quittanceImmob'].setValidators([]);
      this.documentFormGroup.controls['propertyTitle'].setValidators([]);

      this.documentFormGroup.controls['waterBill'].setValidators([]);
      this.documentFormGroup.controls['certImpos'].setValidators([]);
      this.documentFormGroup.controls['taxBill'].setValidators([]);
      this.documentFormGroup.controls['assuranceLogement'].setValidators([]);
      this.documentFormGroup.controls['letterSignedByHost'].setValidators([
        Validators.required,
      ]);
      this.documentFormGroup.controls['letterSignedByHost'].setValidators([
        Validators.required,
      ]);
      this.documentFormGroup.controls['justificatifDomicileHost'].setValidators(
        [Validators.required]
      );
      this.documentFormGroup.controls['justificatifDomicile'].setValidators([
        Validators.required,
      ]);
    } else {
      switch (this.justificatifDomicile2.get('value')?.value) {
        case 1:
          this.documentFormGroup.controls['phoneBill'].setValidators([
            Validators.required,
          ]);
          break;
        case 2:
          this.documentFormGroup.controls['electroBill'].setValidators([
            Validators.required,
          ]);
          break;
        case 3:
          this.documentFormGroup.controls['quittanceImmob'].setValidators([
            Validators.required,
          ]);
          break;
        case 4:
          this.documentFormGroup.controls['propertyTitle'].setValidators([
            Validators.required,
          ]);
          break;
        case 5:
          this.documentFormGroup.controls['waterBill'].setValidators([
            Validators.required,
          ]);
          break;
        case 6:
          this.documentFormGroup.controls['certImpos'].setValidators([
            Validators.required,
          ]);
          break;
        case 7:
          this.documentFormGroup.controls['taxBill'].setValidators([
            Validators.required,
          ]);
          break;
        case 8:
          this.documentFormGroup.controls['assuranceLogement'].setValidators([
            Validators.required,
          ]);
          break;
        default:
          this.documentFormGroup.controls['phoneBill'].setValidators([
            Validators.required,
          ]);
          break;
      }
    }
    this.documentFormGroup.controls['idBack'].updateValueAndValidity();
    this.documentFormGroup.controls['idFace'].updateValueAndValidity();
    this.documentFormGroup.controls['passport'].updateValueAndValidity();
    this.documentFormGroup.controls['sejourFace'].updateValueAndValidity();
    this.documentFormGroup.controls['sejourBack'].updateValueAndValidity();
    this.documentFormGroup.controls[
      'letterSignedByHost'
      ].updateValueAndValidity();
    this.documentFormGroup.controls[
      'justificatifDomicileHost'
      ].updateValueAndValidity();
    this.documentFormGroup.controls[
      'justificatifDomicile'
      ].updateValueAndValidity();
    this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
    this.documentFormGroup.controls['electroBill'].updateValueAndValidity();
    this.documentFormGroup.controls['quittanceImmob'].updateValueAndValidity();
    this.documentFormGroup.controls['propertyTitle'].updateValueAndValidity();
    this.documentFormGroup.controls['waterBill'].updateValueAndValidity();
    this.documentFormGroup.controls['certImpos'].updateValueAndValidity();
    this.documentFormGroup.controls['taxBill'].updateValueAndValidity();
    this.documentFormGroup.controls[
      'assuranceLogement'
      ].updateValueAndValidity();
    this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
  }

  ngOnInit(): void {
    // Debounce keystrokes: one request when the user pauses, not per character.
    this.searchSubject
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((query) => this.searchAddress(query));

    this.route.params.subscribe(params => {
      const candidateId = params['id'];
      this.userID = candidateId;
      if (candidateId) {
        console.log("this.isicandidate 1", this.isCondidat);
        this.isCondidat = true;
        this.formPermanent.patchValue({
          candidat: this.userID
        })
        this.fetchCondidat(candidateId);
        // FILTER ??
        // this.fetchFilter();
        this.maxDate = moment().subtract(18, 'years').format('YYYY-MM-DD');
        if (this.form.get('nationality')?.value != 'autre') {
          if (this.identityCart.get('value')?.value == 1) {
            this.documentFormGroup.controls['idFace'].setValidators([
              Validators.required,
            ]);
            this.documentFormGroup.controls['idBack'].setValidators([
              Validators.required,
            ]);

            this.documentFormGroup.controls['passport'].clearValidators();
            this.documentFormGroup.controls['passport'].setValidators([]);
          } else {
            this.documentFormGroup.controls['passport'].setValidators([
              Validators.required,
            ]);
            this.documentFormGroup.controls['idFace'].clearValidators();
            this.documentFormGroup.controls['idBack'].clearValidators();
            this.documentFormGroup.controls['idFace'].setValidators([]);
            this.documentFormGroup.controls['idBack'].setValidators([]);
          }
        } else {
          this.documentFormGroup.controls['idFace'].setValidators([]);
          this.documentFormGroup.controls['idBack'].setValidators([]);

          this.documentFormGroup.controls['passport'].setValidators([
            Validators.required,
          ]);
          this.documentFormGroup.controls['sejourFace'].setValidators([
            Validators.required,
          ]);
          this.documentFormGroup.controls['sejourBack'].setValidators([
            Validators.required,
          ]);
          this.documentFormGroup.controls['sejourFace'].setValidators([
            Validators.required,
          ]);
          this.documentFormGroup.controls['sejourBack'].setValidators([
            Validators.required,
          ]);
        }
        this.form.controls['nationality'].valueChanges.subscribe((el: any) => {

          if (el === 'autre' && this?.candidatBody?.nationality === 'Nationalité hors union européenne et Suisse') {

          } else {
            if (el !== this?.candidatBody?.nationality) {
              this.candidatBody.passport = '';
              this.candidatBody.idFace = '';
              this.candidatBody.idBack = '';
              this.candidatBody.idBackUrl = '';
              this.candidatBody.idFaceUrl = '';
              this.candidatBody.passportUrl = '';
              this.candidatBody.sejourFace = '';
              this.candidatBody.sejourFaceUrl = '';
              this.candidatBody.sejourBack = '';
              this.candidatBody.sejourBackUrl = '';
              this.deleteFileLocal('idFace');
              this.deleteFileLocal('idBack');
              this.deleteFileLocal('passport');
              this.deleteFileLocal('sejourFace');
              this.deleteFileLocal('sejourBack');
              this.candidatBody = {...this.candidatBody};
            }
          }


          if (el == 'autre') {
            this.documentFormGroup.controls['idFace'].clearValidators();
            this.documentFormGroup.controls['idBack'].clearValidators();
            this.documentFormGroup.controls['idFace'].setValidators([])
            this.documentFormGroup.controls['idBack'].setValidators([]);
            this.documentFormGroup.controls['passport'].setValidators([
              Validators.required,
            ]);
            this.documentFormGroup.controls['sejourFace'].setValidators([
              Validators.required,
            ]);
            this.documentFormGroup.controls['sejourBack'].setValidators([
              Validators.required,
            ]);
          } else {
            this.documentFormGroup.controls['sejourBack'].clearValidators();
            this.documentFormGroup.controls['sejourFace'].clearValidators();
            this.documentFormGroup.controls['passport'].clearValidators();
            this.documentFormGroup.controls['sejourBack'].setValidators([])
            this.documentFormGroup.controls['sejourFace'].setValidators([]);
            this.documentFormGroup.controls['passport'].setValidators([]);
            this.documentFormGroup.controls['idFace'].setValidators([Validators.required]);
            this.documentFormGroup.controls['idBack'].setValidators([Validators.required]);


            if (this.identityCart.get('value')?.value == 2) {
              this.documentFormGroup.controls['idFace'].setValidators([]);
              this.documentFormGroup.controls['idBack'].setValidators([]);
              this.documentFormGroup.controls['passport'].setValidators([Validators.required]);
            }
          }
          this.documentFormGroup.controls['idBack'].updateValueAndValidity();
          this.documentFormGroup.controls['idFace'].updateValueAndValidity();
          this.documentFormGroup.controls['passport'].updateValueAndValidity();
          this.documentFormGroup.controls['sejourFace'].updateValueAndValidity();
          this.documentFormGroup.controls['sejourBack'].updateValueAndValidity();
        });

        if (this.justificatifDomicile.get('value')?.value == 1) {
          this.documentFormGroup.controls['phoneBill'].setValidators([]);
          this.documentFormGroup.controls['electroBill'].setValidators([]);
          this.documentFormGroup.controls['quittanceImmob'].setValidators([]);
          this.documentFormGroup.controls['propertyTitle'].setValidators([]);
          this.documentFormGroup.controls['waterBill'].setValidators([]);
          this.documentFormGroup.controls['certImpos'].setValidators([]);
          this.documentFormGroup.controls['taxBill'].setValidators([]);
          this.documentFormGroup.controls['assuranceLogement'].setValidators([]);
          this.documentFormGroup.controls['letterSignedByHost'].setValidators([Validators.required]);
          this.documentFormGroup.controls['justificatifDomicileHost'].setValidators([Validators.required]);
          this.documentFormGroup.controls['justificatifDomicile'].setValidators([Validators.required]);
        } else {
          switch (this.justificatifDomicile2.get('value')?.value) {
            case 1:
              this.documentFormGroup.controls['phoneBill'].setValidators([Validators.required]);
              break;
            case 2:
              this.documentFormGroup.controls['electroBill'].setValidators([Validators.required]);
              break;
            case 3:
              this.documentFormGroup.controls['quittanceImmob'].setValidators([Validators.required]);
              break;
            case 4:
              this.documentFormGroup.controls['propertyTitle'].setValidators([Validators.required]);
              break;
            case 5:
              this.documentFormGroup.controls['waterBill'].setValidators([Validators.required]);
              break;
            case 6:
              this.documentFormGroup.controls['certImpos'].setValidators([Validators.required]);
              break;
            case 7:
              this.documentFormGroup.controls['taxBill'].setValidators([Validators.required]);
              break;
            case 8:
              this.documentFormGroup.controls['assuranceLogement'].setValidators([Validators.required]);
              break;
            default:
              this.documentFormGroup.controls['phoneBill'].setValidators([Validators.required]);
              break;
          }
        }
        this.identityCart.valueChanges.subscribe(({value}) => {
          if (value == 1) {
            this.documentFormGroup.controls['passport'].clearValidators();
            this.documentFormGroup.controls['passport'].setValidators([]);
            this.documentFormGroup.controls['idFace'].setValidators([
              Validators.required,
            ]);
            this.documentFormGroup.controls['idBack'].setValidators([
              Validators.required,
            ]);
          } else {
            this.documentFormGroup.controls['idFace'].clearValidators();
            this.documentFormGroup.controls['idBack'].clearValidators();
            this.documentFormGroup.controls['idFace'].setValidators([]);
            this.documentFormGroup.controls['idBack'].setValidators([]);
            this.documentFormGroup.controls['passport'].setValidators([
              Validators.required,
            ]);
          }
          this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
          this.documentFormGroup.controls['electroBill'].updateValueAndValidity();
          this.documentFormGroup.controls['quittanceImmob'].updateValueAndValidity();
          this.documentFormGroup.controls['propertyTitle'].updateValueAndValidity();
          this.documentFormGroup.controls['waterBill'].updateValueAndValidity();
          this.documentFormGroup.controls['certImpos'].updateValueAndValidity();
          this.documentFormGroup.controls['taxBill'].updateValueAndValidity();
          this.documentFormGroup.controls['passport'].updateValueAndValidity();

          this.documentFormGroup.controls['sejourFace'].updateValueAndValidity();
          this.documentFormGroup.controls['sejourBack'].updateValueAndValidity();

          this.documentFormGroup.controls['idFace'].updateValueAndValidity();
          this.documentFormGroup.controls['idBack'].updateValueAndValidity();
          this.documentFormGroup.controls['assuranceLogement'].updateValueAndValidity();
          this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();

        });
        this.justificatifDomicile.valueChanges.subscribe(({value}) => {
          if (value == 1) {
            this.documentFormGroup.controls['phoneBill'].setValidators([]);
            this.documentFormGroup.controls['electroBill'].setValidators([]);
            this.documentFormGroup.controls['quittanceImmob'].setValidators([]);
            this.documentFormGroup.controls['propertyTitle'].setValidators([]);
            this.documentFormGroup.controls['waterBill'].setValidators([]);
            this.documentFormGroup.controls['certImpos'].setValidators([]);
            this.documentFormGroup.controls['taxBill'].setValidators([]);
            this.documentFormGroup.controls['assuranceLogement'].setValidators([]);
            this.documentFormGroup.controls['letterSignedByHost'].setValidators([Validators.required]);
            this.documentFormGroup.controls['justificatifDomicileHost'].setValidators([Validators.required]);
            this.documentFormGroup.controls['justificatifDomicile'].setValidators([Validators.required]);
          } else {
            this.documentFormGroup.controls['letterSignedByHost'].setValidators([]);
            this.documentFormGroup.controls['justificatifDomicileHost'].setValidators([]);
            this.documentFormGroup.controls['justificatifDomicile'].setValidators([]);
            this.documentFormGroup.controls['phoneBill'].setValidators([]);
            this.documentFormGroup.controls['electroBill'].setValidators([]);
            this.documentFormGroup.controls['quittanceImmob'].setValidators([]);
            this.documentFormGroup.controls['propertyTitle'].setValidators([]);
            this.documentFormGroup.controls['waterBill'].setValidators([]);
            this.documentFormGroup.controls['certImpos'].setValidators([]);
            this.documentFormGroup.controls['taxBill'].setValidators([]);
            this.documentFormGroup.controls['assuranceLogement'].setValidators([]);
            const value = this.justificatifDomicile2.get('value')?.value;
            switch (value) {
              case 1:
                this.documentFormGroup.get('phoneBill')?.setValidators([
                  Validators.required,
                ]);
                break;
              case 2:
                this.documentFormGroup.get('electroBill')?.setValidators([
                  Validators.required,
                ]);
                break;
              case 3:
                this.documentFormGroup.get('quittanceImmob')?.setValidators([
                  Validators.required,
                ]);
                break;
              case 4:
                this.documentFormGroup.get('propertyTitle')?.setValidators([
                  Validators.required,
                ]);
                break;
              case 5:
                this.documentFormGroup.get('waterBill')?.setValidators([
                  Validators.required,
                ]);
                break;
              case 6:
                this.documentFormGroup.get('certImpos')?.setValidators([
                  Validators.required,
                ]);
                break;
              case 7:
                this.documentFormGroup.get('taxBill')?.setValidators([
                  Validators.required,
                ]);
                break;
              case 8:
                this.documentFormGroup.get('assuranceLogement')?.setValidators([
                  Validators.required,
                ]);
                break;
              default:
                this.documentFormGroup.get('phoneBill')?.setValidators([
                  Validators.required,
                ]);
                break;
            }
            this.justificatifDomicile2.valueChanges.subscribe(({value}) => {
              this.documentFormGroup.controls['phoneBill'].setValidators([]);
              this.documentFormGroup.controls['electroBill'].setValidators([]);
              this.documentFormGroup.controls['quittanceImmob'].setValidators([]);
              this.documentFormGroup.controls['propertyTitle'].setValidators([]);
              this.documentFormGroup.controls['waterBill'].setValidators([]);
              this.documentFormGroup.controls['certImpos'].setValidators([]);
              this.documentFormGroup.controls['taxBill'].setValidators([]);
              this.documentFormGroup.controls['assuranceLogement'].setValidators([]);
              switch (value) {
                case 1:
                  this.documentFormGroup.controls['phoneBill'].setValidators([
                    Validators.required,
                  ]);
                  break;
                case 2:
                  this.documentFormGroup.controls['electroBill'].setValidators([
                    Validators.required,
                  ]);
                  break;
                case 3:
                  this.documentFormGroup.controls['quittanceImmob'].setValidators(
                    [Validators.required]
                  );
                  break;
                case 4:
                  this.documentFormGroup.controls['propertyTitle'].setValidators([
                    Validators.required,
                  ]);
                  break;
                case 5:
                  this.documentFormGroup.controls['waterBill'].setValidators([
                    Validators.required,
                  ]);
                  break;
                case 6:
                  this.documentFormGroup.controls['certImpos'].setValidators([
                    Validators.required,
                  ]);
                  break;
                case 7:
                  this.documentFormGroup.controls['taxBill'].setValidators([
                    Validators.required,
                  ]);
                  break;
                case 8:
                  this.documentFormGroup.controls[
                    'assuranceLogement'
                    ].setValidators([Validators.required]);
                  break;
                default:
                  this.documentFormGroup.controls['phoneBill'].setValidators([
                    Validators.required,
                  ]);
                  break;
              }
              this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
              this.documentFormGroup.controls['electroBill'].updateValueAndValidity();
              this.documentFormGroup.controls['quittanceImmob'].updateValueAndValidity();
              this.documentFormGroup.controls['propertyTitle'].updateValueAndValidity();
              this.documentFormGroup.controls['waterBill'].updateValueAndValidity();
              this.documentFormGroup.controls['certImpos'].updateValueAndValidity();
              this.documentFormGroup.controls['taxBill'].updateValueAndValidity();
              this.documentFormGroup.controls['letterSignedByHost'].updateValueAndValidity();
              this.documentFormGroup.controls['justificatifDomicileHost'].updateValueAndValidity();
              this.documentFormGroup.controls['justificatifDomicile'].updateValueAndValidity();
              this.documentFormGroup.controls['assuranceLogement'].updateValueAndValidity();
            });
          }
          this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
          this.documentFormGroup.controls['electroBill'].updateValueAndValidity();
          this.documentFormGroup.controls['quittanceImmob'].updateValueAndValidity();
          this.documentFormGroup.controls['propertyTitle'].updateValueAndValidity();
          this.documentFormGroup.controls['waterBill'].updateValueAndValidity();
          this.documentFormGroup.controls['certImpos'].updateValueAndValidity();
          this.documentFormGroup.controls['taxBill'].updateValueAndValidity();
          this.documentFormGroup.controls['letterSignedByHost'].updateValueAndValidity();
          this.documentFormGroup.controls['justificatifDomicileHost'].updateValueAndValidity();
          this.documentFormGroup.controls['justificatifDomicile'].updateValueAndValidity();
          this.documentFormGroup.controls['assuranceLogement'].updateValueAndValidity();
        });
        this.justificatifDomicile2.valueChanges.subscribe(({value}) => {
          this.documentFormGroup.controls['phoneBill'].setValidators([]);
          this.documentFormGroup.controls['electroBill'].setValidators([]);
          this.documentFormGroup.controls['quittanceImmob'].setValidators([]);
          this.documentFormGroup.controls['propertyTitle'].setValidators([]);
          this.documentFormGroup.controls['waterBill'].setValidators([]);
          this.documentFormGroup.controls['certImpos'].setValidators([]);
          this.documentFormGroup.controls['taxBill'].setValidators([]);
          this.documentFormGroup.controls['assuranceLogement'].setValidators([]);
          switch (value) {
            case 1:
              this.documentFormGroup.controls['phoneBill'].setValidators([
                Validators.required,
              ]);
              break;
            case 2:
              this.documentFormGroup.controls['electroBill'].setValidators([
                Validators.required,
              ]);

              break;
            case 3:
              this.documentFormGroup.controls['quittanceImmob'].setValidators(
                [Validators.required]
              );
              break;
            case 4:
              this.documentFormGroup.controls['propertyTitle'].setValidators([
                Validators.required,
              ]);
              break;
            case 5:
              this.documentFormGroup.controls['waterBill'].setValidators([
                Validators.required,
              ]);
              break;
            case 6:
              this.documentFormGroup.controls['certImpos'].setValidators([
                Validators.required,
              ]);
              break;
            case 7:
              this.documentFormGroup.controls['taxBill'].setValidators([
                Validators.required,
              ]);
              break;
            case 8:
              this.documentFormGroup.controls[
                'assuranceLogement'
                ].setValidators([Validators.required]);
              break;
            default:
              this.documentFormGroup.controls['phoneBill'].setValidators([
                Validators.required,
              ]);
              break;
          }
          this.documentFormGroup.controls['phoneBill'].updateValueAndValidity();
          this.documentFormGroup.controls['electroBill'].updateValueAndValidity();
          this.documentFormGroup.controls['taxBill'].updateValueAndValidity();
          this.documentFormGroup.controls['certImpos'].updateValueAndValidity();
          this.documentFormGroup.controls['waterBill'].updateValueAndValidity();
          this.documentFormGroup.controls['propertyTitle'].updateValueAndValidity();
          this.documentFormGroup.controls['assuranceLogement'].updateValueAndValidity();
          this.documentFormGroup.controls['quittanceImmob'].updateValueAndValidity();

        });


      if (this.isCondidat) {
        this.getSecteur();
        this.getPosts();
        // Re-filter "Fonction précise" whenever the user changes "Domaine d'activité".
        this.form.get('worktype')?.valueChanges.subscribe((id) => {
          this.applyFonctionFilter(true);
          this.applyProStatusRule(id);
        });
        this.applyProStatusRule(this.form.get('worktype')?.value);
      }
      this.fetchSites();
      }
    });
  }

  onInputChange(event: any) {
    const inputNumber = event?.number;

    if (!inputNumber) return;


    if (inputNumber.startsWith('0')) {
      this.phoneMaxLength = 10;
    } else {
      this.phoneMaxLength = 9;

    }
    if (inputNumber.length > this.phoneMaxLength) {
      this.phoneNumber = inputNumber.slice(0, this.phoneMaxLength);
      this.form.get('phone')?.setValue(this.phoneNumber);
    } else {
      this.phoneNumber = inputNumber;
    }
  }

  onSiretInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const numericValue = inputElement.value.replace(/\D/g, '');
    if (numericValue.length > 14) {
      inputElement.value = numericValue.slice(0, 14);
    } else {
      inputElement.value = numericValue;
    }
    this.form.get('numsiret')?.setValue(inputElement.value);

  }

  onKeyInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const numericValue = inputElement.value.replace(/\D/g, '');
    if (numericValue.length > 2) {
      inputElement.value = numericValue.slice(0, 2);
    } else {
      inputElement.value = numericValue;
    }
    this.form.get('key')?.setValue(inputElement.value);
  }

  onSecurityInputChange(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    const numericValue = inputElement.value.replace(/\D/g, '');
    if (numericValue.length > 13) {
      inputElement.value = numericValue.slice(0, 13);
    } else {
      inputElement.value = numericValue;
    }
    this.form.get('numsocialsecurity')?.setValue(inputElement.value);
  }

  fetchSites() {
    this.missionApi.getProfileRegions().subscribe({
      next: (res: any) => {
        this.depatmentList = res;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  base64ToArrayBuffer(base64: string) {
    const binaryString = atob(base64);
    const len = binaryString.length;
    const bytes = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      bytes[i] = binaryString.charCodeAt(i);
    }

    return bytes.buffer;
  }

  createBlobFromBase64(base64: string, fileName: string, mimeType: string) {
    const arrayBuffer = this.base64ToArrayBuffer(base64);
    const blob = new Blob([arrayBuffer], {type: mimeType});
    return new File([blob], fileName, {type: mimeType});
  }

private async detectFileExtension(blob: Blob): Promise<string | null> {
    const buffer = await blob.slice(0, 8).arrayBuffer();
    const bytes = new Uint8Array(buffer);
    const hex = Array.from(bytes).map(b => b.toString(16).padStart(2, '0')).join('').toUpperCase();

    if (hex.startsWith('25504446')) return '.pdf'; // PDF
    if (hex.startsWith('89504E47')) return '.png'; // PNG
    if (hex.startsWith('FFD8FF')) return '.jpg';   // JPEG
    if (hex.startsWith('47494638')) return '.gif'; // GIF
    if (hex.startsWith('504B0304')) return '.zip'; // ZIP, DOCX, XLSX, PPTX
    if (hex.startsWith('D0CF11E0')) return '.doc'; // Old MS Office

    return null;
  }

  fetchCondidat(id = 0) {
    this.loading = true;
    id = id == 0 ? this.userID : id ;
    this.condidatApi.getCandidatDetailByIdEstaIdV2(id , 0).subscribe({
      next: (res) => {
        this.candidatBody = res;
        this.form.get('mailadress')?.patchValue(res?.mailadress);

        if (this.candidatBody?.passport !== undefined && this.candidatBody?.passport !== null && this.candidatBody?.passport !== '') {
          this.identityCart.get('value')?.setValue(2);
        } else {
          this.identityCart.get('value')?.setValue(1);
        }

        this.pdfLists.map((el) => {
          if (res[el.name]) {

            this.http.get(`${environment.api.BASE_URL}${res[el.name]}`, {
              responseType: 'blob',
              observe: 'response'
            }).subscribe({
              next: async (response: any) => {
                const blob = response.body as Blob;

                let extension = await this.detectFileExtension(blob);

                const fileName = res.fullname + '_' + el.fileName + '.' + extension;

                var img = document.createElement('img');

                // img.src = res[el.name];
                // img.src = 'data:image/' + extension + ';base64,' + res[el.name];

                const objbankDetails =
                  extension == 'pdf'
                    ? 'data:application/' + extension + ';base64,' + blob
                    : 'data:image/' + extension + ';base64,' + blob;
                const blobbankDetails = new File(
                  [objbankDetails],
                  fileName,
                  {
                    type:
                      extension == 'pdf' ? 'application/pdf' : 'image/' + extension,
                  }
                );


                const url = URL.createObjectURL(blob);
                img.src = url;
                img.width = 100;
                this.candidatBody[el.name + 'Url'] = url;
                this.candidatBody[el.name] = blobbankDetails;

                this.documentFormGroup.get(el.name)?.patchValue(this.candidatBody[el.name + 'Url']);

              },
              error: (err: any) => {
                console.error('File download failed:', err);
              }
            });
          }
        });

        this.formPermanent.patchValue({
          fonction: res?.typePosteId,
          worktype: res?.typeSecteurId,
        });
        this.phoneForm.patchValue({phone: res?.numtel?.replace(/\s+/g, '')});
        this.phoneNumber = res?.numtel?.replace(/\s+/g, '');
        this.formAddress.patchValue({
          ...res,
          lat: res?.adresseCandidatDto?.lat,
          lon: res?.adresseCandidatDto?.lon,
          adress: res?.adresseCandidatDto?.additionalAdress,
          postalCode: res?.adresseCandidatDto?.codePostale,
          pays: res?.adresseCandidatDto?.pays,
          ville: res?.adresseCandidatDto?.ville,
          departmentName: res?.adresseCandidatDto?.department,
          note: res?.adresseCandidatDto?.note

        });

        this.form.patchValue({
          ...res,
          civility:
            res?.civility?.toLowerCase() == 'mr'
              ? 'MONSIEUR'
              : res?.civility?.charAt(0).toUpperCase() +
              res?.civility?.slice(1),
          image: res?.photo,
          key: res?.socialKey,
          fonction: res?.typePosteId,
          worktype: res?.typeSecteurId,
          proStatus: res?.proStatus || 'VACATAIRE',
          birthDay: moment(new Date(res?.birthDay)).format('YYYY-MM-DD'),
          graduationYear: moment(new Date(res?.graduationYear)).format('YYYY-MM-DD'),
          nationality:
            res.nationality ==
            'Ressortissant d’un pays de l’union Européenne ou de la Suisse'
              ? 'européenne'
              : res.nationality == 'Nationalité hors union européenne et Suisse'
                ? 'autre'
                : res.nationality,
          anotherNationality:
            res?.nationality?.toLowerCase() == 'autre' ? 1 : 0,
          phone: res?.numtel?.replace(/\s+/g, '')

        });

        this.phoneNumber = res?.numtel?.replace(/\s+/g, '');
        localStorage.setItem(
          'candidat',
          JSON.stringify({
            id: res.id,
            firstname: res.firstname,
            fullname: res.fullname,
            mailadress: res.mailadress,
            photo: res.photo,
            lastname: res.firstname,
            typePosteDto: res.typePosteDto,
            typePosteId: res.typePosteId,
            typeSecteurDto: res.typeSecteurDto,
            typeSecteurId: res.typeSecteurId,
            numsiret: res.numsiret,
            numtel: res?.numtel?.replace(/\s+/g, ''),
            numsocialsecurity: res.numsocialsecurity,
            nationality: res.nationality,
            civility: res.civility,
          })
        );

        this.loading = false;
        if (this.form.get('worktype')?.value == '') {
          this.form.get('fonction')?.patchValue({disabled: true});
        } else {
          this.form.get('fonction')?.enable();
        }
      },
      error: (err) => {
        console.log(err);
        this.loading = false;
      },
    });
  }

  getImage(images: any) {
    if (images.type) {
      this.image = images[0];
      this.candidatBody.imageUrl = images[0];
      this.formData.append('photo', images);
      setTimeout(() => {
        this.submitDocument();
      }, 500);
    }
  }

  getFile(files: any, label: string) {
    if (files) {
      this.file = [...this.file, {label, ...files}];
    }
    this.file = this.file?.filter((el) => el);
    this.file.map((el) => {
      this.documentFormGroup.patchValue({[el.label]: el[0]});
      if (['passport', 'idFace', 'idBack', 'sejourFace', 'sejourBack'].includes(el.label)) {
        const urlLabel = `${el.label}Url`;

        this.candidatBody[urlLabel] = el[0];
        this.documentFormGroup.patchValue({[urlLabel]: el[0]});  // Patch the 'Url' property to the form
      }
    });

  }

  deleteFileLocal(label: string) {
    this.file = this.file.filter((el) => el.label !== label);
    try {
      const baseProperties = [
        'passport',
        'idFace',
        'idBack',
        'sejourFace',
        'sejourBack',
        'bankDetails',
        'socialSecurityCertif',
        'letterSignedByHost',
        'justificatifDomicile',
        'phoneBill',
        'electroBill',
        'quittanceImmob',
        'propertyTitle',
        'waterBill',
        'certImpos',
        'taxBill',
        'assuranceLogement',
        'carteGrise',
        'enrollmentCertificate',
        'cv',
        'firstDiplome',
        'secondDiplome',
        'thirdDiplome',
      ];
      const resetMappings: Record<string, string[]> = {};
      baseProperties.forEach((prop) => {
        resetMappings[prop] = [prop, `${prop}Url`];
      });
      if (resetMappings[label]) {
        resetMappings[label].forEach((property) => {
          if (this.candidatBody && property in this.candidatBody) {
            this.candidatBody[property] = '';
          }
        });
      }
    } catch {

    }
    this.documentFormGroup.get(label)?.patchValue('');
    this.cdr.detectChanges();
  }

  deleteFile(index: number, label: string) {
    // Filter out the file based on the label
    this.file = this.file.filter((el) => el.label !== label);
    try {
      const baseProperties = [
        'passport',
        'idFace',
        'idBack',
        'sejourFace',
        'sejourBack',
        'bankDetails',
        'socialSecurityCertif',
        'letterSignedByHost',
        'justificatifDomicile',
        'phoneBill',
        'electroBill',
        'quittanceImmob',
        'propertyTitle',
        'waterBill',
        'certImpos',
        'taxBill',
        'assuranceLogement',
        'carteGrise',
        'enrollmentCertificate',
        'cv',
        'firstDiplome',
        'secondDiplome',
        'thirdDiplome',
      ];
      const resetMappings: Record<string, string[]> = {};
      baseProperties.forEach((prop) => {
        resetMappings[prop] = [prop, `${prop}Url`];
      });
      if (resetMappings[label]) {
        resetMappings[label].forEach((property) => {
          if (this.candidatBody && property in this.candidatBody) {
            this.candidatBody[property] = '';
          }
        });
      }
    } catch {

    }
    this.condidatApi.deleteFile(this.userID ?? 0, label).subscribe({
      next: (res) => {


      },
      error: (err) => {
        console.log(err);

      },
    });
    // Reset the form control value for the specified label
    this.documentFormGroup.get(label)?.patchValue('');
  }

  getPosts() {
    this.missionApi
      .getAllPostes()
      .then((res) => {
        this.allPostes = res;
        // Filter "Fonction précise" by the currently selected "Domaine d'activité".
        this.applyFonctionFilter();
      })
      .catch((err) => console.log(err));
  }

  /**
   * Keeps "Fonction précise" (poste) options in sync with the selected
   * "Domaine d'activité" (secteur). When resetIfInvalid is true (user changed the
   * domaine), the current fonction is cleared if it no longer belongs to the domaine.
   */
  /** Règle client : le statut proposé dépend de la fonction choisie ; il est corrigé s'il devient interdit. */
  private applyProStatusRule(secteurId: any) {
    this.proStatusOptions = proStatusOptionsFor(secteurId);
    const control = this.form?.get('proStatus');
    const resolved = resolveProStatus(secteurId, control?.value);
    if (control && control.value !== resolved) {
      control.setValue(resolved);
    }
  }

  private applyFonctionFilter(resetIfInvalid: boolean = false): void {
    if (!this.allPostes) {
      return; // postes not loaded yet — getPosts() re-runs this once they are
    }
    const worktype = this.form.get('worktype')?.value;
    this.fonctionOptions = this.allPostes.filter(
      (post: any) => post.typeSecteurId === worktype
    );
    if (resetIfInvalid) {
      const current = this.form.get('fonction')?.value;
      const stillValid = this.fonctionOptions.some((p: any) => p.id === current);
      if (!stillValid) {
        this.form.get('fonction')?.patchValue(null);
      }
    }
  }

  getSecteur() {
    this.missionApi
      .getSecteurs()
      .then((res) => {
        this.domaineOptions = res;
      })
      .catch((err) => console.log(err));
  }

  submit() {
    this.loading = true;
    if (this.isCondidat) {
      // Domaine d'activité (worktype) + Fonction précise (fonction) are required to save.
      const worktypeVal = this.form.get('worktype')?.value;
      const fonctionVal = this.form.get('fonction')?.value;
      if (!worktypeVal || typeof fonctionVal !== 'number') {
        this.loading = false;
        this.alertDialogService.openAlertModal(
          'error',
          'Informations manquantes',
          'Veuillez renseigner le « Domaine d\'activité » et la « Fonction précise » avant d\'enregistrer.',
          'OK'
        );
        return;
      }
      const birthDateValue = this.form.get('birthDay')?.value;
      if (birthDateValue) {
        this.birthDay = moment(birthDateValue).format('YYYY-MM-DD');
      }
      const graduationDateValue = this.form.get('graduationYear')?.value;
      if (graduationDateValue) {
        this.graduationYear = moment(graduationDateValue).format('YYYY-MM-DD');
      }
      const addressData = {
        lat: this.formAddress.get('lat')?.value,
        lon: this.formAddress.get('lon')?.value,
        adress: this.formAddress.get('adress')?.value || '',
        additionalAdress: this.formAddress.get('adress')?.value || '',
        codePostale: this.formAddress.get('postalCode')?.value || '',
        pays: this.formAddress.get('pays')?.value,
        ville: this.formAddress.get('ville')?.value,
        departmentName: this.formAddress.get('departmentName')?.value,
        departmentCode: this.formAddress.get('departmentcode')?.value,
        note: this.formAddress.get('note')?.value,
        department: this.formAddress.get('departmentName')?.value,
        regionName: this.formAddress.get('regionName')?.value || '',
        regionCode: this.formAddress.get('regionCode')?.value || ''
      };

      const body = {
        civility: this.form.get('civility')?.value,
        contracttype: null,
        lastname: this.form.get('lastname')?.value,
        firstname: this.form.get('firstname')?.value,
        birthDay: this.birthDay,
        graduationYear: this.graduationYear,
        fullname:
          this.form.get('lastname')?.value +
          ' ' +
          this.form.get('firstname')?.value,
        ishandicap: this.form.get('ishandicap')?.value,
        handicapsituation: this.form.get('handicapsituation')?.value,
        isliberal: false,
        mailadress: this.form.get('mailadress')?.value,
        numsiren: null,
        numrpps: null,
        numsiret: this.form.get('numsiret')?.value,
        socialKey: this.form.get('key')?.value,
        numsocialsecurity: this.form.get('numsocialsecurity')?.value,
        numtel: this.phoneForm.get('phone')?.value?.number,
        typePosteId: this.form.get('fonction')?.value,
        typeSecteurId: this.form.get('worktype')?.value,
        proStatus: this.form.get('proStatus')?.value,
        nationality: this.form.get('nationality')?.value,
        anotherNationality:
          this.form.get('nationality')?.value?.toLowerCase() == 'autre' ? 1 : 0,
        adresseCandidatDto: addressData
      };
      this.condidatApi
        .upadateCandidat(body, this.userID)
        .subscribe({
          next: (res) => {
            this.flag.displayFlag(
              'Compte candidat modifié avec succés !',
              FlagType.success
            );
            this.loading = false;
            this.fetchCondidat();
          },
          error: (err) => {
            this.flag.displayFlag('Error !', FlagType.error);
            this.loading = false;
          },
        });
    }
  }

  submitDocument() {
    this.loading = true;
    this.file.forEach((el) => {
      this.formData.append(el.label, el[0]);
    });
    this.condidatApi
      .uploadFileCandidat(this.formData, this.userID )
      .subscribe({
        next: (res) => {
          this.file.map((el) => {
            this.formData.delete(el.label);
          });
          this.flag.displayFlag(
            'Vos données ont été mises à jour avec succès !',
            FlagType.success
          );
          this.submit();
          this.formData.delete('photo');

          this.fetchCondidat();
          this.loading = false;
        },
        error: (err) => {
          this.file.map((el) => {
            this.formData.delete(el.label);
          });
          this.formData.delete('photo');
          this.flag.displayFlag('Error !', FlagType.error);
          this.loading = false;
        },
      });
  }

  openAddDisponibility() {
    this.router.navigate(['planning']);
  }

  fetchFilter(): void {
    this.loading = true;
    this.condidatApi.getFilterPermanat(this.userID ).subscribe({
      next: (res: any) => {
        this.formPermanent.patchValue(res);
        if (res?.nonAvailabilityDates?.length > 0) {
          this.nonAvailabilityDates = res?.nonAvailabilityDates
            ?.map((el: any) => {
              return (
                'De ' +
                moment(el?.fromDate).format('DD-MM-YYYY') +
                " Jusqu'a " +
                moment(el?.toDate).format('DD-MM-YYYY')
              );
            })
            .join(' , ');
        }

        this.loading = false;
      },
      error: (err) => {
        console.log(err);
        this.loading = false;
      },
    });
  }

  submitFilter(): void {
    this.loading = true;
    this.condidatApi.filterPermanat(this.formPermanent.value).subscribe({
      next: (res) => {
        this.flag.displayFlag(
          'Filter permanent modifié avec succés ! ',
          FlagType.success
        );
        this.loading = false;
      },
      error: (err) => {
        this.flag.displayFlag('Error !', FlagType.success);
        this.loading = false;
      },
    });
  }

  addDisponibility({start, end}: any) {
    this.missionApi
      .addAvailability(this.userID , {
        fromDate: start,
        toDate: end,
      })
      .subscribe({
        next: ({availabilityDates}) => {
          this.flag.displayFlag(
            'Disponibilté ajouter avec succés !',
            FlagType.success
          );
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  autoCompleteOnChange(event: any) {
    this.getAddresses(event?.value);
  }

  getAddresses(wordKey: string) {
    if (wordKey && wordKey.trim()) {
      this.searchSubject.next(wordKey.trim());
    } else {
      this.addressList = [];
      this.addressSearched = false;
    }
  }

  private searchAddress(query: string): void {
    if (!query || query.trim().length < 3) {
      this.addressList = [];
      this.addressSearched = false;
      this.addressLoading = false;
      return;
    }
    this.addressLoading = true;
    this.addressSearched = true;
    this.establishmentService.getAddress(query, 'france').subscribe({
      next: (value) => {
        // Keep only real, usable French addresses (drop country/region-only hits).
        this.addressList = (value || []).filter(
          (v: any) => v?.address?.country_code === 'fr' && !!v?.address?.postcode
        );
        this.addressLoading = false;
      },
      error: () => {
        this.addressList = [];
        this.addressLoading = false;
      },
    });
  }

  addressSelected(item: any): void {
    const address = item?.address || {};
    this.formAddress.get('lat')?.patchValue(item?.lat);
    this.formAddress.get('lon')?.patchValue(item?.lon);
    this.formAddress.get('adress')?.patchValue(this.getAdresseFormated(item));
    this.formAddress.get('postalCode')?.patchValue(address.postcode || '');
    this.formAddress.get('pays')?.patchValue(address.country || '');
    this.formAddress.get('ville')?.patchValue(address.city || '');
    this.formAddress.get('departmentName')?.patchValue(address.county || address.city || '');

    // No postcode → cannot resolve a region; skip to avoid geo.api.gouv.fr/regions/undefined.
    if (!address.postcode) {
      return;
    }
    this.establishmentService.getRegionByPostalCode(address.postcode).subscribe({
      next: (res) => {
        const code = res?.[0]?.codeRegion;
        if (!code) {
          return;
        }
        this.formAddress.get('regionCode')?.patchValue(code);
        this.establishmentService.getRegionByCode(code).subscribe({
          next: (region) => this.formAddress.get('regionName')?.patchValue(region?.nom || ''),
          error: () => {},
        });
      },
      error: () => {},
    });
  }

  // protected readonly domaineOptions = domaineOptions;
  protected readonly CountryISO = CountryISO;
  protected readonly SearchCountryField = SearchCountryField;
  protected readonly civilityOptions = civilityOptions;
  protected readonly civilityForProfileOptions = civilityForProfileOptions;
  protected readonly nationalityOptions = registerNationalityOptions;
  // protected readonly fonctionOptions = fonctionOptions;
}
